import React, { useCallback, useEffect, useMemo } from 'react';
import i18n from 'i18next';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import useStyles from './MissionCreation.styles';
import MissionConfigurationUpload from './MissionConfigurationUpload';
import useAgent from '../../../common/hooks/useAgent';
import missionAgent from '../../agents/missionAgent';
import { Loader } from '../../../common/components/loaders';
import MissionForm from '../form/MissionForm';
import { Container } from '../../../common/components/layout';
import { useClientContext } from '../../../common/contexts/abilityContext';

const MissionCreation = ({ onBackClick, onCreatedSuccess }) => {
  const classes = useStyles();

  const [validateMissionConfiguration, missionConfiguration, isValidatingMissionConfiguration] = useAgent(missionAgent.validateMissionConfiguration);
  const [createMission, createdMission] = useAgent(missionAgent.createMission);

  useEffect(() => {
    if (missionConfiguration) {
      toast.success(i18n.t('mission.message.uploadSuccess'));
    }
  }, [missionConfiguration]);

  useEffect(() => {
    if (createdMission) {
      toast.success(i18n.t('mission.message.creationSuccess'));
      onCreatedSuccess(createdMission.id);
    }
  }, [createdMission, onCreatedSuccess]);

  const clientId = useClientContext();
  const mission = useMemo(() => {
    if (!missionConfiguration) return undefined;
    const { missionName, missionId, ...cleanedMissionConfiguration } = missionConfiguration;
    return { ...cleanedMissionConfiguration, id: missionId, name: missionName, clientId: clientId || '' };
  }, [missionConfiguration, clientId]);

  const handleUploadClick = useCallback((formData) => validateMissionConfiguration(formData), [validateMissionConfiguration]);

  const handleSubmit = useCallback(
    (values) => {
      createMission(values);
    },
    [createMission]
  );

  if (!missionConfiguration) {
    return (
      <Container className={classes.container}>
        {isValidatingMissionConfiguration && <Loader className={classes.loader} />}
        {!isValidatingMissionConfiguration && <MissionConfigurationUpload onUploadClick={handleUploadClick} />}
      </Container>
    );
  }

  return (
    <Container>
      <MissionForm mission={mission} onBackClick={onBackClick} onSubmit={handleSubmit} />
    </Container>
  );
};

MissionCreation.propTypes = {
  onBackClick: PropTypes.func,
  onCreatedSuccess: PropTypes.func,
};

MissionCreation.defaultProps = {
  onBackClick: undefined,
  onCreatedSuccess: undefined,
};
export default MissionCreation;
